<div class="verify">
  <div class="verify__wrapper">
    <div class="verify__container">
      <div class="verify__left">
        @if (!isAlreadyVerified) {
          <form
            (ngSubmit)="verifyUser(resetPassForm)"
            #resetPassForm="ngForm"
            aria-labelledby="title"
            class="form"
          >
            <div class="form-group template full-width">
              <div
                id="pass"
                class="e-float-input"
                [ngClass]="{ 'e-success': password.valid }"
              >
                <input
                  type="password"
                  id="input-password"
                  name="password"
                  [(ngModel)]="newPassword"
                  #password="ngModel"
                  required
                  pattern="(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d$@$!%#^*?&].{11,}"
                />
                <span class="e-float-line"></span>
                <label
                  class="e-float-text"
                  [ngClass]="{
                    'e-label-top': password !== '',
                    'e-label-bottom': password == ''
                  }"
                  for="name"
                >Create Password</label>
                @if (!showPasswordFlag) {
                  <mat-icon
                    class="pass-icon"
                    (click)="togglePassword('input-password')"
                  >visibility_off</mat-icon>
                }
                @if (showPasswordFlag) {
                  <mat-icon
                    class="pass-icon"
                    (click)="togglePassword('input-password')"
                  >visibility</mat-icon>
                }
              </div>
              @if (password.invalid && password.touched) {
                @if (password.errors?.required) {
                  <p class="caption status-danger">
                    Password is required!
                  </p>
                }
                @if (password.dirty) {
                  <p class="caption status-danger">
                    Password should contains minimum 12 characters, one lower case and
                    one upper case.
                  </p>
                }
              }
            </div>
            <div class="form-group template full-width">
              <div class="e-float-input" [ngClass]="{ 'e-success': password.valid }">
                <input
                  type="password"
                  id="input-re-password"
                  name="rePass"
                  [(ngModel)]="confirmPassword"
                  #rePass="ngModel"
                  required
                  pattern="(?=.*[a-z])(?=.*[A-Z])[A-Za-z\d$@$!%#^*?&].{11,}"
                />
                <span class="e-float-line"></span>
                <label
                  class="e-float-text"
                  [ngClass]="{
                    'e-label-top': rePass !== '',
                    'e-label-bottom': rePass == ''
                  }"
                  for="name"
                >Confirm Password</label>
                @if (!showRePasswordFlag) {
                  <mat-icon
                    class="pass-icon"
                    (click)="togglePassword('input-re-password')"
                  >visibility_off</mat-icon>
                }
                @if (showRePasswordFlag) {
                  <mat-icon
                    class="pass-icon"
                    (click)="togglePassword('input-re-password')"
                  >visibility</mat-icon>
                }
              </div>
              @if (rePass.touched) {
                @if (rePass.invalid && rePass.errors?.required) {
                  <p class="caption status-danger">
                    Password confirmation is required!
                  </p>
                }
                @if (password.value != rePass.value && !rePass.errors?.required) {
                  <p class="caption status-danger">
                    Password does not match the confirm password.
                  </p>
                }
              }
            </div>
            <div class="form-group template center">
              <div class="submitBtn">
                <button
                  style="width: 10vw"
                  class="submit-btn e-btn"
                  id="submit-btn"
                  ejs-progressbutton
                  content="Save Password"
                  [enableProgress]="true"
                  [spinSettings]="spinCenter"
                  [animationSettings]="slideRight"
                  cssClass="e-outline e-success"
                  type="submit"
                  [disabled]="
                    submitted ||
                    !resetPassForm.valid ||
                    password.value != rePass.value
                  "
                >
                  Save Password
                </button>
              </div>
            </div>
          </form>
        }

        @if (isAlreadyVerified) {
          <div class="evta-alert evta-alert-danger" role="alert">
            <p class="alert-title">
              <b>Password has already been set</b>
            </p>
          </div>
        }
      </div>

      <div class="verify__right">
        <section class="info-msg" aria-label="Welcome">
          @if (!isAlreadyVerified) {
            <div class="info-msg__title">Welcome to easyVTA</div>
            <div class="info-msg__step">
              Please create a password to complete your registration.
            </div>
          }
          @if (isAlreadyVerified) {
            <div class="info-msg__step">
              If you already have an account, please log in
              <a class="login-link" routerLink="../login">here.</a>
            </div>
            <div class="info-msg__step">
              If you need to reset your password, please
              <a class="login-link" routerLink="../request-password">click here.</a>
            </div>
          }
        </section>
      </div>
    </div>
  </div>
</div>
